import router from '@/router'
import {
  clearPopupSessionData,
  canShowEnjoyTrialPopup,
  canShowTrialNotAvailablePopup,
} from '@/utils/trial-plan.utils'

const SET_SHOW_TRIAL_NOT_ELIGIBLE_MODAL = 'SET_SHOW_TRIAL_NOT_ELIGIBLE_MODAL'
const SET_SHOW_ENJOY_TRIAL_MODAL = 'SET_SHOW_ENJOY_TRIAL_MODAL'

const _state = {
  isShowTrialNotEligibleModal: false,
  isShowEnjoyTrialModal: false,

}

const getters = {
  isShowTrialNotEligibleModal(state) {
    return state.isShowTrialNotEligibleModal
  },
  isShowEnjoyTrialModal(state) {
    return state.isShowEnjoyTrialModal
  },
}

const actions = {
  hideTrialNotAvailableModalAction({ commit }) {
    commit(SET_SHOW_TRIAL_NOT_ELIGIBLE_MODAL, false)
    router.replace({
      path: '/apps/presentations',
    })
  },
  hideEnjoyTrialModalAction({ commit }) {
    commit(SET_SHOW_ENJOY_TRIAL_MODAL, false)
  },

  checkToShowTrialModalAction({ commit, rootState }, user) {
    if (canShowTrialNotAvailablePopup(user) && !rootState.isTrialPlan) {
      commit(SET_SHOW_TRIAL_NOT_ELIGIBLE_MODAL, true)
      clearPopupSessionData(user)
    }

    if (canShowEnjoyTrialPopup(user)) {
      commit(SET_SHOW_ENJOY_TRIAL_MODAL, true)
      clearPopupSessionData(user)
    }
  },
}

const mutations = {
  [SET_SHOW_TRIAL_NOT_ELIGIBLE_MODAL]: (state, value) => {
    state.isShowTrialNotEligibleModal = value
  },
  [SET_SHOW_ENJOY_TRIAL_MODAL]: (state, value) => {
    state.isShowEnjoyTrialModal = value
  },
}

const trialPlan = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default trialPlan
